
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--oversea",
      function () {
        return require("private-next-pages/--oversea/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--oversea"])
      });
    }
  